module.exports = __webpack_public_path__ + "img/dataAssetGreen.11a889ee.png";